import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getLists } from '../services/Apis';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function useGlobal() {

  const getListType = (type) => {
      return useQuery({
        queryKey: ['List'],
        queryFn: () => getLists(type),
        cacheTime: Infinity,
        refetchOnMount: false,
        staleTime: Infinity,
      });
    }

  return {
    getListType: getListType,
  };
}